import styled from "styled-components";

export const NotificationsCardsContainer = styled.div`
  > *:not(:last-child) {
    margin-bottom: 1.2rem;
  }
`;
